
<template>
  <div style="position: relative;">
    <el-button
      type="primary"
      class="btnBack"
      size="small"
      @click="back"
    >
      &lt;&lt;返回
    </el-button>
    <el-tabs
      v-model="activeName"
      type="card"
      @tab-click="handleTabClick"
    >
      <el-tab-pane
        label="编写专著"
        name="ky04dtl"
      >
        <ky04dtl />
      </el-tab-pane>
      <el-tab-pane
        label="成员列表"
        name="MemberList"
      >
        <MemberList />
      </el-tab-pane>
      <el-tab-pane label="任务管理" name="WorkTask">
        <WorkTask ref="task" />
      </el-tab-pane>
      <el-tab-pane
        label="参编者"
        name="ky0402"
      >
        <ky0402 />
      </el-tab-pane>
      <el-tab-pane
        label="参编单位"
        name="ky0403"
      >
        <ky0403 />
      </el-tab-pane>
      <el-tab-pane
        label="附件"
        name="Appendix"
      >
        <Appendix />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ky04dtl from './ky04edit'
import MemberList from '@/views/managesystem/gz/com/MemberList.vue'
import WorkTask from '@/views/managesystem/gz/com/WorkTask.vue'
import Appendix from '@/views/managesystem/gz/com/Appendix.vue'
import ky0402 from '@/views/managesystem/gz/ky/ky0402/index.vue'
import ky0403 from '@/views/managesystem/gz/ky/ky0403/index.vue'
export default {
  components: {
    ky04dtl, MemberList, WorkTask, ky0402, ky0403, Appendix
  },
  data() {
    return {
      postId: null,
      activeName: 'ky04dtl'
    }
  },
  mounted() {
    this.postId = this.$route.params.id
    this.moduleCode = 'ky04'
  },
  activated() {
    this.postId = this.$route.params.id
    var activeName = this.$route.params.activeName
    if (activeName) {
      this.activeName = activeName
      if (this.activeName === 'WorkTask') {
        this.$refs.task.init()
      }
    } else {
      this.activeName = 'ky04dtl'
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    handleTabClick(tab, event) {
      // 成员列表
      if (tab.name === 'MemberList') {
        this.$bus.emit('MemberListInit')
      }
      // 任务管理
      if (tab.name === 'WorkTask') {
        this.$refs.task.init()
      }
      // 参编者
      if (tab.name === 'ky0402') {
        this.$bus.emit('handleInitky0402')
      }
      // 参编单位
      if (tab.name === 'ky0403') {
        this.$bus.emit('handleInitky0403')
      }
      // 附件
      if (tab.name === 'Appendix') {
        this.$bus.emit('handleInitAppendix')
      }
    }
  }
}
</script>
<style scoped>
.btnBack {
  position: absolute;
  right: 5px;
  top: 2px;
  z-index: 99;
}
</style>
